import { fetchContingencyOptions } from '@/services/constants/contingencyOptions';
angular.module('leanlaw').directive('llMatterInfoEdit', [function () {
  return {
    restrict: 'E',
    template: require("./views/matterInfoEdit.html"),
    scope: {
      me: '=',
      matter: "=",
      customFields: "=",
      enable: "=?",
      onSave: "=?",
      onCancel: "=?"
    },
    controller: ['$scope', '$rootScope', 'matterTagsService', 'alerts', function ($scope, $rootScope, matterTagsService, alerts) {
      activate();
      $scope.data = {};
      $scope.originationStepDownChange = originationStepDownChange;

      // Contingency field dropdown options (loaded from API)
      $scope.caseStatusOptions = [];
      $scope.marketingSourceOptions = [];

      // Date validation helper for client-side validation
      $scope.isInvalidDate = function (value) {
        if (value == null || value === '') return false; // Empty is allowed (cleared)
        const date = value instanceof Date ? value : new Date(value);
        return isNaN(date.getTime());
      };

      // Amount validation helper - negative numbers are invalid
      $scope.isInvalidAmount = function (value) {
        if (value == null || value === '') return false; // Empty is allowed
        const num = Number(value);
        return isNaN(num) || num < 0;
      };

      // Validation for origination step-down period - must be positive when provided
      $scope.isInvalidStepDownPeriod = function () {
        const value = $scope.matter?.billing?.originationStepDownPeriodInMonths;
        if (value == null || value === '') return false; // Empty is allowed (optional field)
        const num = Number(value);
        return isNaN(num) || num < 1; // Must be positive integer if provided
      };
      $scope.hasInvalidDates = function () {
        // Check origination step-down date only if that section is visible and enabled
        const hasOriginationSettings = $scope.me?.company?.settings?.report?.originationStepDownPeriodInMonths;
        const stepDownEnabled = hasOriginationSettings && !$scope.matter?.billing?.originationStepDownDisabled;
        const invalidStepDownDate = stepDownEnabled && $scope.isInvalidDate($scope.matter?.billing?.originationStepDownStart);
        return $scope.isInvalidDate($scope.matter?.opened) || invalidStepDownDate || $scope.matter?.billing?.type === 'contingency' && ($scope.isInvalidDate($scope.matter?.expectedSettlementDate) || $scope.isInvalidDate($scope.matter?.settlementDate));
      };
      $scope.hasInvalidAmounts = function () {
        if ($scope.matter?.billing?.type !== 'contingency') return false;
        return $scope.isInvalidAmount($scope.matter?.expectedSettlementAmount) || $scope.isInvalidAmount($scope.matter?.expectedCaseCosts);
      };

      // Combined validation for disabling save button
      $scope.hasValidationErrors = function () {
        // Date Opened is required
        if (!$scope.matter?.opened) return true;
        // Check AngularJS form validity (catches HTML5 input validation errors)
        if ($scope.infoForm && $scope.infoForm.$invalid) return true;
        return $scope.hasInvalidDates() || $scope.hasInvalidAmounts() || $scope.isInvalidStepDownPeriod();
      };

      ///////////////////////////////////

      function activate() {
        matterTagsService.getMatterTags().then(mattertags => {
          if (!mattertags) return;
          $scope.data.matterTags = mattertags;
        });
        const deactivate = $rootScope.$on('$stateChangeStart', event => {
          if ($scope.infoForm?.$dirty) {
            alerts.warning("You have unsaved changes. Save or undo changes first.");
            event.preventDefault();
          } else {
            deactivate();
          }
        });
        setUpOriginationStepDown();

        // Watch for matter to be loaded before initializing contingency fields
        // The matter object is bound via '=' and may not be available immediately
        $scope.$watch('matter.billing.type', billingType => {
          if (billingType === 'contingency') {
            initializeContingencyFields();
            loadContingencyOptions();
          }
        });
      }

      // Load contingency dropdown options from API
      let contingencyOptionsLoaded = false;
      function loadContingencyOptions() {
        if (contingencyOptionsLoaded) return; // Prevent duplicate calls
        contingencyOptionsLoaded = true;
        fetchContingencyOptions().then(({
          caseStatuses,
          marketingSources
        }) => {
          $scope.caseStatusOptions = caseStatuses;
          $scope.marketingSourceOptions = marketingSources;
          $scope.$applyAsync();
        }).catch(error => {
          contingencyOptionsLoaded = false; // Allow retry on error
          console.error('Failed to load contingency options:', error);
          alerts.error('Failed to load contingency field options. Please refresh the page.');
        });
      }

      // Initialize contingency fields for contingency matters
      // Fields are directly on matter object (not nested): caseStatus, marketingSource,
      // expectedSettlementDate, expectedSettlementAmount, expectedCaseCosts, settlementDate
      let contingencyFieldsInitialized = false;
      function initializeContingencyFields() {
        if (contingencyFieldsInitialized) return; // Prevent duplicate initialization
        contingencyFieldsInitialized = true;

        // Convert date strings to Date objects for date inputs
        if ($scope.matter.expectedSettlementDate) {
          $scope.matter.expectedSettlementDate = new Date($scope.matter.expectedSettlementDate);
        }
        if ($scope.matter.settlementDate) {
          $scope.matter.settlementDate = new Date($scope.matter.settlementDate);
        }
      }
      function originationStepDownChange() {
        $scope.matter.billing.originationStepDownDisabled = $scope.matter.billing.originationStepDownStatus.id;
      }
      function setUpOriginationStepDown() {
        if ($scope.me.company.settings.report?.originationStepDownPeriodInMonths) {
          $scope.originationStepDownOptions = [{
            id: false,
            label: "Enable"
          }, {
            id: true,
            label: "Disable"
          }];
          $scope.matter.billing.originationStepDownStatus = $scope.originationStepDownOptions.find(option => option.id === $scope.matter.billing.originationStepDownDisabled) || $scope.originationStepDownOptions[0];
          // Only convert to Date if value exists and is not null/empty
          if ($scope.matter.billing.originationStepDownStart) {
            $scope.matter.billing.originationStepDownStart = new Date($scope.matter.billing.originationStepDownStart);
          }
          originationStepDownChange();
        }
      }
      $scope.$watch('infoForm.$dirty', dirty => {
        $scope.$emit('matterBillingIsDirty', dirty);
      }, true);
      $scope.$watchGroup(['infoForm.originationStepDownStatus.$dirty', 'infoForm.originationStepDownPeriodInMonths.$dirty', 'infoForm.originationStepDownStart.$dirty'], infoForm => {
        $scope.$emit('originationStepDownChanged', infoForm.some(dirty => dirty));
      });
    }]
  };
}]);